export default __webpack_public_path__ + "static/media/user-default.d8e64cf2.png";